import axios from "axios";
import Vue from "vue";
import { BASEURL, CINEMADESTINATIONS } from "@/config/index";
import { shouldPingHost, setPingStatus, getLastPingStatus, getOrPingHost } from "@/helper/pingCache";

export async function pingHttp(url) {
  try {
    if (!url) {
      return { up: "N", status: false, reason: "Invalid URL" };
    } else {
      const res = await axios.get(url, { timeout: 2500 });
      return { up: "Y", status: res.status, reason: "" };
    }
  } catch (err) {
    return { up: "N", status: false, reason: err.code || err.message };
  }
}

export const getCinemaBaseURL = (cinemaId) => {
  let cinemaURL = BASEURL;

  console.log(
    "CINEMADESTINATIONS",
    CINEMADESTINATIONS,
    process.env.NO_OF_CINEMAS
  );

  if (CINEMADESTINATIONS && CINEMADESTINATIONS.length && cinemaId) {
    console.log("COMING HERE INSIDE 15");
    let cinemaLocations = CINEMADESTINATIONS.find(
      (x) => x.cinema_id == cinemaId
    );
    cinemaURL =
      cinemaLocations && cinemaLocations.hasOwnProperty("cinema_url")
        ? cinemaLocations["cinema_url"]
        : BASEURL;
  }

  return cinemaURL || BASEURL;
};

export default (params = {}) => {
  const { cinema_id = null } = params;

  console.log("params", { params, cinema_id });

  let baseURL = getCinemaBaseURL(cinema_id);

  console.log("baseURL", baseURL);

  const instance = axios.create({
    baseURL: baseURL || BASEURL,
  });
  let JWT = window.localStorage.getItem("JWT_TOKEN");
  if (JWT) {
    instance.defaults.headers.common["Authorization"] = JWT;
  }

  instance.defaults.headers.common["x-cinema-source"] =
    process.env.CINEMA_SOURCE;

  instance.defaults.headers.common["x-cinema-destination"] = cinema_id
    ? cinema_id
    : process.env.CINEMA_SOURCE;

  instance.interceptors.response.use(
    async function (response) {
      // Do something with response data
      if (response && response["config"] && response["config"]['baseURL']) {
        const hostOrigin = response["config"]['baseURL'];

        if (hostOrigin) {
          try {
            const isOnline = await getOrPingHost(hostOrigin, pingHttp);

            if (isOnline['up'] == "N") {
              vmVue.$root.$emit("bv::show::modal", "connectionOffline");
              return Promise.reject(new Error(`Host ${hostOrigin} is offline`));
            }
          } catch (err) {
            // Handle ping errors gracefully
            vmVue.$root.$emit("bv::show::modal", "connectionOffline");
            return Promise.reject(new Error(`Host ${hostOrigin} is offline`));
          }
        }
        // if (shouldPingHost(hostOrigin)) {
        //   const isOnline = await pingHttp(hostOrigin);
        //   setPingStatus(hostOrigin, isOnline);

        //   if (isOnline['up'] == "N") {
        //     vmVue.$root.$emit("bv::show::modal", "connectionOffline");
        //     return Promise.reject(new Error(`Host ${hostOrigin} is offline`));
        //   }
        // } else {
        //   const isOnline = getLastPingStatus(hostOrigin);
        //   if (isOnline['up'] == "N") {
        //     vmVue.$root.$emit("bv::show::modal", "connectionOffline");
        //     return Promise.reject(new Error(`Host ${hostOrigin} is offline (cached)`));
        //   }
        // }
      }
      return response;
    },
    function (error) {
      // Do something with response error
      if (error && error.response && error.response.status == 403) {
        Vue.toasted.show("You are not authorized");
      } else if (error && error.response && error.response.status == 401) {
        localStorage.clear();
        Vue.cookie.delete("BRHSID");
        vmVue.$router.push({
          path: "/", // '/go-to-login'
        });
      } else if (error.code === 'ECONNABORTED' || !error.response) {

        const CRITICAL_ENDPOINTS = [
          `/user/check`,
          `/api/admin/getOrgDetails`,
          `/health-meta`,
          `/checkOnlyAuthenticatorEnabled`,
          `/api/admin`,
          `/api/`,
        ]

        const requestPath = new URL(error.config.url, error.config.baseURL).pathname;

        const isCritical = CRITICAL_ENDPOINTS.some(endpoint =>
          requestPath.startsWith(endpoint)
        );

        const currentRoute = vmVue.$router.currentRoute['path'];
        if (isCritical && currentRoute !== '/connection-issue') {
          vmVue.$root.$emit("bv::show::modal", "connectionOffline");
          return Promise.reject(new Error(`Host ${error.config.baseURL} is offline`));
        } else {
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
  );
  return instance;
};



// WEBPACK FOOTER //
// ./src/services/Api.js